var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _g, _rect11, _rect12, _rect13, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRectCardIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 100,
    viewBox: "0 0 119 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.4861,
    y: 54.7236,
    width: 59.5411,
    height: 38.2035,
    rx: 3.31997,
    fill: "url(#paint0_radial_296_664)",
    stroke: "url(#paint1_linear_296_664)",
    strokeWidth: 0.737771
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8728 98.486C25.3115 99.0427 25.7057 100 26.4962 100H95.6231C96.3588 100 96.7735 99.1547 96.3232 98.5728L94.5286 96.2538C94.3609 96.0371 94.1024 95.9103 93.8284 95.9103H28.8348C28.6012 95.9103 28.3772 96.0025 28.2114 96.167L25.8728 98.486Z",
    fill: "#00FD8E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: -0.000488281,
    y: 45.0039,
    width: 21.3954,
    height: 20.6576,
    rx: 2.66721,
    fill: "#00FD8E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 19.1816,
    y: 14.0176,
    width: 21.5155,
    height: 19.9151,
    rx: 2.66721,
    fill: "#00FD8E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 21.3286,
    y: 15.9866,
    width: 17.2214,
    height: 15.9767,
    rx: 2.29832,
    stroke: "#85FBCC",
    strokeWidth: 0.737771
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 50.9058,
    width: 21.5155,
    height: 19.9151,
    rx: 2.66721,
    fill: "#00FD8E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 53.053,
    y: 1.96898,
    width: 17.2214,
    height: 15.9767,
    rx: 2.29832,
    stroke: "#85FBCC",
    strokeWidth: 0.737771
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 1.96898,
    y: 47.0776,
    width: 17.2214,
    height: 15.9767,
    rx: 2.29832,
    stroke: "#85FBCC",
    strokeWidth: 0.737771
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 78.9412,
    y: 16.9688,
    width: 21.5155,
    height: 19.9151,
    rx: 2.66721,
    fill: "#00FD8E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 81.0881,
    y: 18.938,
    width: 17.2214,
    height: 15.9767,
    rx: 2.29832,
    stroke: "#85FBCC",
    strokeWidth: 0.737771
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 96.6477,
    y: 43.5286,
    width: 21.5155,
    height: 19.9151,
    rx: 2.66721,
    fill: "#00FD8E"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.33,
    x: 99.23,
    y: 46.1106,
    width: 16.231,
    height: 15.4932,
    rx: 2.29832,
    stroke: "#85FBCC",
    strokeWidth: 0.737771
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.21,
    x: 45.7415,
    y: 40.5774,
    width: 30.2486,
    height: 27.2975,
    rx: 3.68886,
    fill: "#00FD8E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21,
    filter: "url(#filter0_f_296_664)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.0037,
    y: 38.364,
    width: 33.1997,
    height: 31.7242,
    rx: 3.68886,
    fill: "#00FD8E"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 49.4304,
    y: 42.7908,
    width: 23.6087,
    height: 22.8709,
    rx: 3.68886,
    fill: "url(#paint2_linear_296_664)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 49.0615,
    y: 43.1597,
    width: 24.3465,
    height: 22.8709,
    rx: 4.05774,
    stroke: "white",
    strokeWidth: 0.737771
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.21,
    x: 45.7415,
    y: 40.5774,
    width: 30.2486,
    height: 28.0353,
    rx: 3.68886,
    fill: "#00FD8E"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21,
    filter: "url(#filter1_f_296_664)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.5281,
    y: 38.364,
    width: 34.6753,
    height: 32.4619,
    rx: 3.68886,
    fill: "#00FD8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_296_664",
    x: 42.0526,
    y: 35.4129,
    width: 39.1019,
    height: 37.6263,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.47554,
    result: "effect1_foregroundBlur_296_664"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_296_664",
    x: 40.577,
    y: 35.4129,
    width: 40.5775,
    height: 38.3641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.47554,
    result: "effect1_foregroundBlur_296_664"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_296_664",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-11.5521 16.8186) rotate(25.2724) scale(287.982 1076.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.259615,
    stopColor: "#040209"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FD8E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_296_664",
    x1: 21.2965,
    y1: 33.2316,
    x2: 28.9547,
    y2: 97.1652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DFDA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_296_664",
    x1: 38.0967,
    y1: 35.589,
    x2: 62.5249,
    y2: 64.5744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FD8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009755"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectCardIcon2);
export default __webpack_public_path__ + "static/media/RectCardIcon2.a6cad43c20c162f717fed5b4309ca3e9.svg";
export { ForwardRef as ReactComponent };